export default __webpack_public_path__ + "static/justin1-d7ac43d18403cd25bfc60376ba1a2c48.png";